var zhCN = {
  personal_card_set_status: '设置你的工作状态',
  personal_card_dept: '部门',
  personal_card_email: '邮箱',
  personal_card_phone: '手机',
  personal_card_self_hide: '已设置隐藏',
  personal_card_hide: '对方已设置隐藏',
  personal_card_schedule: '日程',
  personal_card_see_schedule: '查看日程',
  personal_card_location: '地点',
  personal_card_send_message: '发消息',
  personal_card_video_call: '通话',
  personal_card_remark: '备注名',
  personal_card_set_remark: '设置对方的备注名',
  personal_card_alias_group: '群昵称',
  personal_card_position: '职务',
  personal_card_reports_to: '直属上级',
  personal_card_alias: '别名',
  personal_card_account: '账号',
  personal_card_employee_number: '工号',
  personal_card_no_support_tips: '不支持与外部联系人聊天',
  personal_card_sex_male: '男',
  personal_card_sex_female: '女',
  personal_card_unknown: '保密',
  personal_card_computer_online: '电脑设备在线',
  personal_card_phone_online: '手机设备在线',
  personal_card_offline: '所有设备离线',
  personal_card_copy_success: '复制成功',
  personal_card_enterprise: '企业',
  personal_card_add_as_contact: '申请添加为联系人',
  personal_card_accept: '同意添加为联系人',
  personal_card_permission_denied: '您的操作权限不足',
  personal_card_file_not_exists: '文件（夹）不存在',
  personal_card_chat_not_exists: '群聊已解散',
  personal_card_msg_not_exists: '当前消息已失效',
  personal_card_unsupported_msg_type: '暂不支持该类型消息',
  personal_card_app_event_msg_handled: '已处理',
  personal_card_invalid_user: '帐号异常',
  personal_card_token_expired: '群链接&群二维码已过期',
  personal_card_inviter_not_in_chat: '分享该群的用户已退群',
  personal_card_recall_msg_unforward: '消息已被撤回无法转发',
  personal_card_nofind_forward_msg: '转发失败，原消息已不存在',
  personal_card_user_not_exists: '用户不存在',
  personal_card_secure_file_cross_auth: '操作失败，非安全文档所属成员',
  personal_card_not_contact_relation: '不支持与非联系人发起聊天',
  personal_card_err_insufficient_card_callback_arguments: '输入不能为空',
  personal_card_err_invalid_card_callback_arguments: '入参错误',
  personal_card_err_apply_already_handled: '申请已处理',
  personal_card_chat_robot_not_exists: '该群聊机器人已被移除',
  personal_card_already_contact: '已经是联系人了',
  personal_card_user_not_in_company: '不支持转让至外部联系人',
  personal_card_no_in_contacts: '不支持对{orgType}外的人执行此操作',
  personal_card_robot_desc: '简介',
  personal_card_robot_own_corp: '所属组织',
  personal_card_robot_open_app: '打开应用',
  personal_card_robot_corp_app: '系统应用',
  personal_card_robot_open_plate_app: '开发平台应用',
  personal_card_robot_team_id: '团队号',
  personal_card_robot_isv: '服务商应用',
  personal_card_robot_responser: '负责人',
  personal_card_robot_developer: '所有者',
  personal_card_user_personal_user: '个人用户',
  personal_card_user_click_view: '点击查看',
  personal_card_user_hidden: '隐藏显示',
  personal_card_user_turn_display: '开启显示，他人可见',
  personal_card_user_memo: '备注',
  personal_card_user_view_history: '查看历史消息',
  personal_card_user_copy: '复制',
  personal_card_user_away: '电脑设备离开',
  personal_card_tag_external: '外部',
  personal_card_tag_delete: '已删除',
  personal_card_telephone: '电话',
  personal_card_add_contact: '添加联系人',
  personal_card_already_friends: '已经是好友关系了',
  personal_card_application_expired: '该申请已失效',
  personal_card_already_external_contact: '已经是外部联系人了',
  general_err_network: '网络异常，请稍后再试',
  user_hint_external_contact_basic_limit: '基础套餐企业无法使用该功能，请联系管理员'
};

export { zhCN as default };
